    //table thead 
   export const tabHead = [
       
        {
         name:'Id'
        },
        {
         name:'Line Of Business',
        },
        {
         name:'Insurance Product',
        },
        {
         name:'Insurance Type',
        },
        {
         name:'Insurance Type Description'
        },
        {
         name:'Insured Address'
        },
        {
         name:'Business By'
        },
        {
         name:'Insured Name'
        },
        {
         name:'Insurer'
        },
        {
         name:'Policy Start Date'
        },
        {
         name:'Policy End Date'
        },
        {
         name:'Policy Number'
        },
        {
         name:'Registration Number'
        },
        {
         name:'Vehicle Make'
        },
        {
         name:'Model'
        },
        {
         name:'Year of Registration'
        },
        {
         name:'Engine Number'
        },
        {
         name:'Chassis Number'
        },
        {
         name:'Description'
        },
        {
         name:'Sum Insured'
        },
        {
         name:'Motor OD Premium Amount'
        },
        {
         name:'Motor TP Premium Amount'
        },
        {
         name:'Premium'
        },
        {
         name:'GST'
        },
        {
         name:'Gross Premium'
        },
        {
         name:'OD Brokerage Rate'
        },
        {
         name:'TP Brokerage Rate'
        },
        {
         name:'OD Commision'
        },
        {
         name:'TP Commision'
        },
        {
         name:'Brokerage Eligible'
        },
        {
         name:'Brokerage Received'
        },
        {
         name:'Reward Eligibled'
        },
        {
         name:'Reward Received'
        },
        {
         name:'Total Commision'
        },
        {
         name:'Previous Policy No'
        },
        {
         name:'Previous Insurer'
        },
        {
         name:'Cover Note NO'
        },
        {
         name:'Mode Of Paymentd'
        },
        {
         name:'Retro Active Date'
        },
        {
         name:'BQP'
        },
        {
         name:'Risk Location'
        },
        {
         name:'Assests Covered'
        },
        {
         name:'PAN No'
        },
        {
         name:'Deductible'
        },
        {
         name:'Financier Name'
        },
        {
         name:'Mobile No'
        },
        {
         name:'Entry Date'
        },
        {
         name:'Insured Type'
        },
        {
         name:'Client Id'
        },
      ]